module.exports = __webpack_public_path__ + "media/images/new/icons/youtube@2x-b339bfacf0fdb98a1457b30644db7b6f.png";